import { IconeAvatar } from './styles'

const Avatar = () => <IconeAvatar src="https://github.com/Ceb0lo.png" />

export default Avatar
